
import { FireIcon } from '@heroicons/react/24/outline';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Badge } from '@/components/ui/badge';
import { getPopularFAQs } from '@/data/support/faqs';

const PopularFAQs = () => {
  const popularFAQs = getPopularFAQs();

  return (
    <div className="mb-12">
      <div className="flex items-center mb-6">
        <FireIcon className="h-6 w-6 text-orange-500 mr-2" />
        <h2 className="text-2xl font-bold text-foreground">
          Most Popular Questions
        </h2>
      </div>
      
      <div className="bg-gradient-to-r from-orange-50 to-primary/5 border border-orange-200 rounded-lg p-6">
        <Accordion type="single" collapsible className="w-full space-y-3">
          {popularFAQs.map((faq) => (
            <AccordionItem 
              key={faq.id} 
              value={faq.id}
              className="bg-card border rounded-lg px-4"
            >
              <AccordionTrigger className="text-left hover:no-underline py-4">
                <div className="flex items-center justify-between w-full mr-4">
                  <h3 className="font-semibold text-foreground text-sm">
                    {faq.question}
                  </h3>
                  <Badge variant="secondary" className="text-xs">
                    Popular
                  </Badge>
                </div>
              </AccordionTrigger>
              <AccordionContent className="pb-4">
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default PopularFAQs;
